'use client';

import { A11yText } from '@paypoteam/ui-components/A11yText';
import { buttonVariants } from '@paypoteam/ui-components/Button';
import { P } from '@paypoteam/ui-components/P';
import { Title } from '@paypoteam/ui-components/Title';

import { cn } from '@/lib/utils';

import type { ShareholdersPdfRowProps } from '../ShareholdersSection.types';

import { SHAREHOLDERS_SECTION_CONTENT } from '@/static/content/pl/shareholders';

export default function ShareholdersPdfRow({
    document: { label, url },
    caption,
    size = 'm',
    'data-test-id': dataTestId,
}: ShareholdersPdfRowProps) {
    return (
        <div
            className={cn(
                'flex flex-col gap-3 md:flex-row md:items-center',
                size === 'm' ? 'py-4 md:py-6' : 'py-2 md:gap-4',
            )}
            data-test-id={dataTestId}
        >
            <div className="flex min-w-0 flex-1 flex-col gap-1">
                <Title
                    size={size}
                    className="break-words"
                >
                    {label}
                </Title>

                {caption && (
                    <P
                        size="2xs"
                        weight="medium"
                        className="text-typo-secondary"
                    >
                        {caption}
                    </P>
                )}
            </div>

            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                    buttonVariants({ variant: 'outline', size: 's' }),
                    'w-fit shrink-0',
                )}
                data-test-id={dataTestId && `${dataTestId}-download`}
            >
                <span aria-hidden>
                    {SHAREHOLDERS_SECTION_CONTENT.downloadPdf}
                </span>

                <A11yText>
                    {`${SHAREHOLDERS_SECTION_CONTENT.downloadPdf}: ${label} (${SHAREHOLDERS_SECTION_CONTENT.opensInNewTab})`}
                </A11yText>
            </a>
        </div>
    );
}
